import { normalizeCampaignParticipant } from '@/lib/adapters/campaignParticipant.adapters'
import type { CampaignParticipantType, ParticipantStatus } from '@/types/campaignParticipant.types'
import type {
  ParticipantColumnServerType,
  ParticipantsColumnType,
} from '@/types/campaignParticipants.types'

const cleanDuplicatesAndMerge = (
  existingItems: CampaignParticipantType[],
  newItems: CampaignParticipantType[],
): CampaignParticipantType[] => {
  if (existingItems.length) {
    const existingItemsIds = new Set(existingItems.map((item) => item.id))
    return [...existingItems, ...newItems.filter((item) => !existingItemsIds.has(item.id))]
  } else {
    return newItems
  }
}

export const normalizeCampaignParticipantsColumn = (
  columnType: ParticipantStatus,
  newColumnData: ParticipantColumnServerType,
  existingColumnData?: ParticipantsColumnType['items'],
): ParticipantsColumnType => {
  const normalizedParticipants = newColumnData.data.map((participant) =>
    normalizeCampaignParticipant(participant),
  )
  return {
    type: columnType,
    items: existingColumnData?.length
      ? cleanDuplicatesAndMerge(existingColumnData, normalizedParticipants)
      : normalizedParticipants,
    page: newColumnData.meta.current_page,
    lastPage: newColumnData.meta.last_page,
    total: newColumnData.meta.total,
    loading: false,
  }
}
